/**
 * This isn't used anywhere, only in a service with a method that is also deprecated
 * @deprecated
 */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Commenting decorator to prevent angular AOT Compiler to catch it and complain
// @Component({
//   selector: 'hb-confirmation-dialog',
//   templateUrl: 'confirmationDialog.component.html',
// })
export class ConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  close(value: boolean): void {
    this.dialogRef.close(value);
  }
}
